import {FC} from 'react';
//mui
import {CircularProgressProps, CircularProgress as MuiLoader, SxProps, Theme} from '@mui/material';
import Box from '@mui/material/Box';
//styles
import {loaderStyle} from './Loader.styles';

interface ExtendedLoaderProps extends CircularProgressProps {
	parentClassName?: SxProps<Theme>;
	sx?: SxProps<Theme>;
}

const Loader: FC<ExtendedLoaderProps> = ({parentClassName, sx, ...rest}) => {
	return (
		<Box sx={{...parentClassName, ...loaderStyle.wrapper}}>
			<MuiLoader {...rest} thickness={3} sx={{strokeLinecap: 'round', ...sx}} />
		</Box>
	);
};

export default Loader;
